import store from '@/store/index';
const lemonx = "/lemonxapp-v1/invoke-v3/";
const appUrl = "/wikifxapp-v1/invoke-v3/";
// const statebase = store.state.base;
import request from '@/utils/request';

const url = window.isx ? lemonx : appUrl;
console.log(window.isx, 9999)
export function v3 (data, headers) {
  const o = Object.values(headers);
  const v = o[0].split('$')[0];
  return request({
    url: url + v,
    method: 'post',
    data,
    headers
  });
};